var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localized } from '@lit/localize';
import { CommonActions } from '../../../localization/helpers.js';
import {} from '@galigeo-store/galigeojs';
let SelectMultipleApiNodeInput = class SelectMultipleApiNodeInput extends LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
    }
    firstUpdated(_changedProperties) {
        this.fetchOptions();
        super.firstUpdated(_changedProperties);
    }
    fetchOptions() {
        if (!this.apiService || !this.input?.options_url) {
            console.warn('API service or options_url not provided');
            this.setOptions(this.input?.options || []);
            return;
        }
        this.apiService.get(this.input.options_url)
            .then(data => {
            const fetchedOptions = this.mapDataToOptions(data);
            if (fetchedOptions.length === 0) {
                this.setOptions([]);
                return;
            }
            this.reorderOptionsAndSetDefaultValue(fetchedOptions);
            this.setOptions(fetchedOptions);
            this.requestUpdate();
        })
            .catch(error => {
            console.error(`Error fetching options from ${this.input.options_url}:`, error);
            this.setOptions([]);
        });
    }
    mapDataToOptions(data) {
        if (this.input.id_field == null || this.input.label_field == null) {
            console.warn('id_field or label_field not defined in input configuration');
            return [];
        }
        return data.map((d) => {
            const value = d[this.input.id_field];
            const label = d[this.input.label_field];
            return {
                value: value,
                label: String(label)
            };
        });
    }
    reorderOptionsAndSetDefaultValue(options) {
        const currentValue = this.input?.value;
        if (currentValue && Array.isArray(currentValue) && currentValue.length > 0) {
            // Reorder options to show selected ones first
            const selectedOptions = options.filter(opt => currentValue.includes(opt.value));
            const unselectedOptions = options.filter(opt => !currentValue.includes(opt.value));
            options.splice(0, options.length, ...selectedOptions, ...unselectedOptions);
        }
        else if ((currentValue == null || !Array.isArray(currentValue) || currentValue.length === 0) && options.length > 0) {
            // Set empty array as default value if no value is set
            if (!this.input?.nullable) {
                this.input.value = [];
                this.dispatchEvent(new CustomEvent('node-input-change', {
                    detail: { key: this.key, input: this.input },
                    bubbles: true,
                    composed: true
                }));
            }
        }
    }
    setOptions(options) {
        this.options = options;
    }
    onInputChange(event) {
        const selectedValues = event.detail.value;
        const firstOption = this.options[0];
        // Maintain type consistency with the options
        if (firstOption && typeof firstOption.value === 'number') {
            this.input.value = selectedValues.map(v => typeof v === 'number' ? v : parseFloat(String(v)));
        }
        else {
            this.input.value = selectedValues.map(v => String(v));
        }
        this.dispatchEvent(new CustomEvent('node-input-change', {
            detail: { input: this.input },
            bubbles: true,
            composed: true
        }));
    }
    // Refresh button handler
    refreshOptions() {
        this.fetchOptions();
    }
    render() {
        return html `
        <select-multiple-input
            .options=${this.options}
            .value=${this.input?.value ?? []}
            size="small"
            @select-multiple-change=${this.onInputChange}
        ></select-multiple-input>
        <div class="margin"></div>
        <simple-button
            class="refresh-button"
            label="${CommonActions.refresh()}"
            primary
            size="small"
            variant="secondary"
            @button-click=${this.refreshOptions}
        ></simple-button>
    `;
    }
};
SelectMultipleApiNodeInput.styles = css `
      .margin {
          height: 6px; /* Réduction de 25% */
      }

      .refresh-button {
      }
    `;
__decorate([
    property({ type: String })
], SelectMultipleApiNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], SelectMultipleApiNodeInput.prototype, "input", void 0);
__decorate([
    property({ type: Object })
], SelectMultipleApiNodeInput.prototype, "apiService", void 0);
__decorate([
    state()
], SelectMultipleApiNodeInput.prototype, "options", void 0);
SelectMultipleApiNodeInput = __decorate([
    localized(),
    customElement('select-multiple-api-node-input')
], SelectMultipleApiNodeInput);
export { SelectMultipleApiNodeInput };
//# sourceMappingURL=SelectMultipleApiNodeInput.js.map